export const setHospitalCredentials = (credentials) => ({
  type: 'hospital-login/SET_HOSPITAL_CREDENTIALS',
  payload: credentials
});

export const setHospitalAuthenticated = (isAuthenticated) => {
  localStorage.setItem('isAuthenticated', isAuthenticated ? 'true' : 'false');
  return {
    type: 'hospital-login/SET_HOSPITAL_AUTHENTICATED',
    payload: isAuthenticated
  };
};

export const hospitalLoginActions = {
  LOGIN_HOSPITAL: {
    REQUEST: 'login/loginHospitalRequest',
    SUCCESS: 'login/loginHospitalSuccess',
    FAILURE: 'login/loginHospitalFailure',
    RESET: 'login/loginHospitalReset'
  },
  SET_HOSPITAL: {
    CREDENTIALS: 'hospital-login/SET_HOSPITAL_CREDENTIALS',
    AUTHENTICATED: 'hospital-login/SET_HOSPITAL_AUTHENTICATED'
  }
};
export const hospitalLogoutActions = {
  LOGOUT_HOSPITAL: {
    REQUEST: 'login/logoutHospitalRequest',
    SUCCESS: 'login/logoutHospitalSuccess',
    FAILURE: 'login/logoutHospitalFailure',
    RESET: 'login/logoutHospitalReset'
  }
};
